import React from "react";
import styles from "./styles.module.css";

const MensagemErroForm = ({erro}) => {
    return (
        <div className={styles.erro}>{erro}</div>
    )
}

export default MensagemErroForm;